import React from 'react';
import PropTypes from 'prop-types';
import { Label } from './styles';
import { Tip } from 'modules/common/components';
const propTypes = {
  children: PropTypes.node.isRequired,
  ignoreTrans: PropTypes.bool,
  toolTip: PropTypes.string
};

function ControlLabel(props, { __ }) {
  const { children, ignoreTrans, required } = props;
  if (props.toolTip && props.toolTip !== '') {
    return (
      <Tip text={props.toolTip}>
        <Label>{ignoreTrans ? children : __(children)}</Label>
      </Tip>
    );
  } else {
    return (
      <Label>
        {ignoreTrans ? children : __(children)}
        <span>{required ? ' *' : ''}</span>
      </Label>
    );
  }
}

ControlLabel.propTypes = propTypes;
ControlLabel.contextTypes = {
  __: PropTypes.func
};

export default ControlLabel;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/Label.js